var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.op] || "-",
          backUrl: _vm.backUrl,
          "close-now-tag": "",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formData",
              staticClass: "formData form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formData,
                "label-width": "100px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "所属应用：", prop: "applicationId" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              model: {
                                value: _vm.formData.applicationId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "applicationId", $$v)
                                },
                                expression: "formData.applicationId",
                              },
                            },
                            [
                              _vm._l(_vm.appList, function (item, index) {
                                return [
                                  _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                      disabled: item.disabled,
                                    },
                                  }),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        { attrs: { data: _vm.signConfigList, border: "" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "七日连续签到",
                              width: "130",
                              prop: "label",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "奖励类型", width: "160" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        model: {
                                          value: scope.row.RewardType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "RewardType",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.RewardType",
                                        },
                                      },
                                      _vm._l(
                                        _vm.rewardTypeOptions,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "奖励数额", width: "160" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input-number", {
                                      attrs: {
                                        min: 0,
                                        max: 9999,
                                        step:
                                          scope.row.RewardType === 2 ? 0.01 : 1,
                                        "controls-position": "right",
                                        "step-strictly": "",
                                      },
                                      model: {
                                        value: scope.row.RewardAmount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "RewardAmount",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.RewardAmount",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "看视频额外奖励",
                              "min-width": "180",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                        "active-text": "开启",
                                        "inactive-text": "关闭",
                                      },
                                      model: {
                                        value: scope.row.DoubleRewardSwitch,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "DoubleRewardSwitch",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.DoubleRewardSwitch",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: scope.row.DoubleRewardSwitch,
                                            expression:
                                              "scope.row.DoubleRewardSwitch",
                                          },
                                        ],
                                      },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            min: 0,
                                            step: 0.01,
                                            "controls-position": "right",
                                            "step-strictly": "",
                                            placeholder: "请输入倍数",
                                          },
                                          model: {
                                            value:
                                              scope.row.DoubleRewardMultiple,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "DoubleRewardMultiple",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.DoubleRewardMultiple",
                                          },
                                        }),
                                        _vm._v("倍 "),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "mt10" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "platform:system:payment:save",
                            "platform:system:payment:update",
                          ],
                          expression:
                            "['platform:system:payment:save', 'platform:system:payment:update']",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isDisabled,
                          expression: "!isDisabled",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }